import { HardBreak } from "@tiptap/extension-hard-break";
export const BreakOrSubmit = HardBreak.extend({
    addKeyboardShortcuts() {
        return {
            "Shift-Enter": () => this.editor.commands.setHardBreak(),
            "Mod-Enter": () => {
                this.options.submit();
                return true;
            },
            Enter: () => {
                if (this.options.aggressive) {
                    this.options.submit();
                    return true;
                }
                return false;
            },
        };
    },
});
//# sourceMappingURL=BreakOrSubmit.js.map